import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import { getUserLevel } from '../services/levels';

const Chip = styled.span`
  display: inline-flex; align-items: center; margin-left: .35rem; padding: 0 .4rem;
  border-radius: 999px; font-size: .66rem; font-weight: 800; line-height: 1.55;
  background: rgba(124,58,237,.16); color: ${theme.colors.primaryLight};
  border: 1px solid rgba(124,58,237,.3); vertical-align: middle; white-space: nowrap;
`;

/* Petit badge de niveau à afficher à côté d'un pseudo (chat, amis…). Se charge en cache.
 * `min` : niveau minimum pour l'afficher (par défaut 2 → on n'affiche pas « Niv.1 », trop de bruit). */
export default function LevelBadge({ userId, min = 2 }) {
  const [lvl, setLvl] = useState(null);
  useEffect(() => {
    let alive = true;
    if (userId) getUserLevel(userId).then((v) => { if (alive) setLvl(v); });
    return () => { alive = false; };
  }, [userId]);
  if (!lvl || lvl.level < min) return null;
  return <Chip title={`Niveau ${lvl.level} · ${lvl.status}`}>Niv.{lvl.level}</Chip>;
}
